import { css } from 'design'

export const questionContainerStyles = css({
  backdropFilter: 'blur(1px)',
  background: 'rgb(80 80 80 / 50%)',
  padding: '$4 !important',

  '>*': {
    pointerEvents: 'auto !important',
  },
})

export const spacerStyles = css({
  flexGrow: 1,
})
